module.exports = __webpack_public_path__ + "img/logo-malam-white.6d101d57.png";